import { useStoreMap } from 'effector-react'

import type { Message } from '../api'
import * as chatModel from '../model'

export function useChannelMessage(messageId: string | undefined): Message | null {
    const message = useStoreMap({
        store: chatModel.$chatChannelMessageById,
        keys: [messageId],
        fn: (messages, [id]) => (id ? (messages[id] ?? null) : null),
    })

    return message
}
